import { CloseOutlined, CheckOutlined } from "@ant-design/icons";
import { Button, Checkbox, Col, Divider, Form, Input, Row, Space, Transfer } from "antd";
import { useEffect, useState } from "react";
import { GrupoContaBancoModel } from "../../../../models/grupoContaBanco/grupoContaBancoModel";
import { atualizarGrupoContaBanco, cadastrarGrupoContaBanco } from "../../../../services/grupoContaBancoService";
import { buscarAgrupamentoContaBanco, sincronizarAgrupamentoContaBanco } from "../../../../services/agrupamentoContaBancoService";
import { buscarContaBanco } from "../../../../services/contaBancoService";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { setModalCadastrarGrupoContaBanco } from "../../../../redux/slices/grupoContaBanco/grupoContaBancoSlice";
import { resetAgrupamentoContaBanco } from "../../../../redux/slices/agrupamentoContaBanco/agrupamentoContaBancoSlice";

type FormProps = {
  denominacao: string;
  ordem: number;
  ativo: boolean;
};

interface TransferItem {
  key: string;
  title: string;
}

const CadastroGrupoContaBancoModal = () => {
  const grupoContaBancoState = useAppSelector((state) => state.grupoContaBanco);
  const agrupamentoState = useAppSelector((state) => state.agrupamentoContaBanco);
  const contaBancoState = useAppSelector((state) => state.contaBanco);

  const dispatch = useAppDispatch();

  const [form] = Form.useForm<FormProps>();
  const [targetKeys, setTargetKeys] = useState<string[]>([]);

  const editar = Object.values(grupoContaBancoState.entity).length !== 0;

  useEffect(() => {
    if (editar) {
      form.setFieldsValue({ ...grupoContaBancoState.entity });
      dispatch(buscarAgrupamentoContaBanco({ idGrupoContaBanco: grupoContaBancoState.entity.id }));
    } else {
      setTargetKeys([]);
      dispatch(resetAgrupamentoContaBanco());
    }
    dispatch(buscarContaBanco({ pesquisar: null, id: null, idEmpresa: null }));
  }, [grupoContaBancoState.entity]);

  // Sync targetKeys when agrupamento list changes
  useEffect(() => {
    setTargetKeys(agrupamentoState.list.map((a) => String(a.idContaBanco)));
  }, [agrupamentoState.list]);

  const dataSource: TransferItem[] = (contaBancoState.list || []).map((c: any) => ({
    key: String(c.id),
    title: c.denominacaoContaBancoAutomatica || c.denominacaoContaBancoUsuario || c.denominacaoPersonalizada || `${c.nomeBanco} - ${c.conta}`,
  }));

  const handleTransferChange = (nextTargetKeys: string[]) => {
    setTargetKeys(nextTargetKeys);
  };


  const submit = async (values: FormProps) => {
    if (editar) {
      const args: GrupoContaBancoModel = { id: grupoContaBancoState.entity.id, ...values };
      dispatch(atualizarGrupoContaBanco({ value: args }));
      if (grupoContaBancoState.entity.id) {
        dispatch(
          sincronizarAgrupamentoContaBanco({
            idGrupoContaBanco: grupoContaBancoState.entity.id,
            listaIdContaBanco: targetKeys.map(Number),
          })
        );
      }
    } else {
      const args: GrupoContaBancoModel = { id: null, ...values, ativo: values.ativo ?? true };
      dispatch(cadastrarGrupoContaBanco({ value: args, listaIdContaBanco: targetKeys.map(Number) }));
    }
  };

  const voltar = () => {
    dispatch(setModalCadastrarGrupoContaBanco(false));
  };

  return (
    <Form form={form} onFinish={submit} layout="vertical" initialValues={{ ativo: true }}>
      <Row gutter={12}>
        <Col span={16}>
          <Form.Item
            label="Denominação"
            name="denominacao"
            rules={[{ required: true, message: "Digite a Denominação" }]}
          >
            <Input style={{ width: "100%" }} type="text" maxLength={100} />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            label="Ordem"
            name="ordem"
            rules={[{ required: true, message: "Digite a Ordem" }]}
          >
            <Input style={{ width: "100%" }} type="number" min={0} />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item label="Ativo" name="ativo" valuePropName="checked">
            <Checkbox>Ativo</Checkbox>
          </Form.Item>
        </Col>
      </Row>

      <Divider orientation="left">Contas Bancárias do Grupo</Divider>
      <Transfer
        dataSource={dataSource}
        targetKeys={targetKeys}
        onChange={handleTransferChange}
        render={(item) => item.title}
        showSearch
        filterOption={(inputValue, item) =>
          item.title.toLowerCase().includes(inputValue.toLowerCase())
        }
        titles={["Disponíveis", "Associadas"]}
        listStyle={{ width: "100%", height: 300 }}
        locale={{
          itemUnit: "conta",
          itemsUnit: "contas",
          searchPlaceholder: "Buscar conta...",
        }}
      />

      <Divider />
      <Row gutter={12}>
        <Col span={24} className="modalFooter">
          <Space size="middle">
            <Button className="cancelButton" onClick={voltar} icon={<CloseOutlined />}>
              FECHAR
            </Button>
            <Button htmlType="submit" icon={<CheckOutlined />} className="buttonPrimary">
              {editar ? "ATUALIZAR" : "SALVAR"}
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
};
export default CadastroGrupoContaBancoModal;
